module.exports = __webpack_public_path__ + "img/92198.0144ab04.svg";